import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {IssueId, OverrideTagValues} from "common/types/issue";

export default function updateIssueOverrideTagValues(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_OVERRIDE_TAG_VALUES_UPDATE,
    (
      organisationId: OrganisationId,
      issueId: IssueId,
      overrides: OverrideTagValues,
    ) => {
      return requestor
        .put(
          `${basePath}/organisation/${organisationId}/issue/${issueId}/override_tag_values`,
          {overrides},
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
